import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";

import Home from "./pages/Home";
import Event from "./pages/Event";
import CheckoutResult from "./pages/CheckoutResult";
import SplashScreen from "./pages/SplashScreen";
import ResumenEntradas from "./pages/ResumenEntradas";
import Feedback from "./pages/Feedback";
 // eslint-disable-next-line
import QrScanner from "./pages/QrScanner";
import BottomBar from "./components/BottomBar";
 import BottomBarAdmin from "./components/BottomBarAdmin";


 // eslint-disable-next-line
import TicketsList from "./pages/TicketsList.js";
import MisEntradas from "./pages/MisEntradas.js";
import Register from "./pages/Register.js";
import Cortesia from "./pages/Cortesia.js";
import InscripcionPublica from "./pages/InscripcionPublica";
import GuestList from "./pages/GuestList";
import Dashboard from "./pages/Dashboard";
import ValidarTicket from "./pages/ValidarTicket";
import LoginPlataforma from "./pages/plataforma/LoginPlataforma";
import LoginVendedor from "./pages/plataforma/LoginVendedor";
import ScannerLogin from "./pages/plataforma/ScannerLogin";
import ClienteEventos from "./pages/plataforma/ClienteEventos";
import ClienteVendedores from "./pages/plataforma/ClienteVendedores";
import ClienteInvitados from "./pages/plataforma/ClienteInvitados";
import ClienteEstadisticas from "./pages/plataforma/ClienteEstadisticas";
import InscripcionCliente from "./pages/plataforma/InscripcionCliente";
import WaitlistForm from "./pages/WaitlistForm";
import WaitlistEstado from "./pages/WaitlistEstado";
import VendedorPanel from "./pages/plataforma/VendedorPanel";
import AdminPanel from "./pages/plataforma/AdminPanel";
import SubirComprobante from "./pages/plataforma/SubirComprobante";
import ComprarEmpresa from "./pages/plataforma/ComprarEmpresa";
import CompraResultado from "./pages/plataforma/CompraResultado";
import "./index.css";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPassword from "./pages/ForgotPassword";
import ReactGA from "react-ga4";
import { EmpresaProvider, useEmpresa } from "./context/EmpresaContext";

ReactGA.initialize("G-F6155HMFRQ");

function AdminAccess() {
  const { empresa } = useEmpresa();
  return empresa?.role === "superadmin" ? <AdminPanel /> : <LoginPlataforma />;
}

function SplashRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => navigate("/ADMIN", { replace: true }), 1400);
    return () => clearTimeout(timer);
  }, [navigate]);
  return <SplashScreen />;
}

function AppContent() {
  const location = useLocation();
  const normalizedPath = location.pathname
    .replace(/\/{2,}/g, "/")
    .replace(/\/+$/, "") || "/";
  const isEmpresaAdmin =
    normalizedPath.toLowerCase() === "/admin" ||
    /^\/[^/]+\/admin$/i.test(normalizedPath);

  // rutas donde NO queremos BottomBar
  const hideBottomBarOn = ["/", "/login", "/register"];
  // Ocultar también en formulario público (no tiene sesión)
  const isPublicForm =
    location.pathname.startsWith("/espera/") ||
    location.pathname.startsWith("/inscripcion/") ||
    location.pathname.startsWith("/validar/") ||
    location.pathname.startsWith("/i/") ||
    location.pathname.startsWith("/plataforma/") ||
    location.pathname.startsWith("/cliente/") ||
    location.pathname.startsWith("/vendedor/") ||
    location.pathname.startsWith("/comprar/") ||
    location.pathname.startsWith("/scanner") ||
    location.pathname.toLowerCase().includes("/scanner") ||
    isEmpresaAdmin;

  const shouldHideBottom =
    hideBottomBarOn.includes(location.pathname.toLowerCase()) || isPublicForm;

  if (location.pathname !== normalizedPath) {
    return <SplashRedirect />;
  }

  return (
    <main
      style={{
        margin: 0,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: "100vw",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <Routes>
        <Route path="/" element={<Navigate to="/ADMIN" replace />} />
        <Route path="/login" element={<Navigate to="/ADMIN" replace />} />
        {/* <Route path="/" element={<QrScanner />} /> */}

        <Route path="/home" element={<Home />} />
        <Route path="/event/:idEvento" element={<Event />} />
        <Route path="/checkout/:result" element={<CheckoutResult />} />
        <Route path="/resumenEntradas" element={<ResumenEntradas />} />
        <Route path="/MisEntradas" element={<MisEntradas />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/register" element={<Register />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route
          path="/cortesia"
          element={
            <ProtectedRoute>
              <Cortesia />
            </ProtectedRoute>
          }
        />
        <Route
          path="/TicketsList"
          element={
            <ProtectedRoute>
              <TicketsList />
            </ProtectedRoute>
          }
        />
        <Route path="/inscripcion/:eventoId" element={<InscripcionPublica />} />
        <Route path="/validar/:inscripcionId" element={<ValidarTicket />} />
        <Route path="/plataforma/login" element={<Navigate to="/ADMIN" replace />} />
        <Route path="/vendedor/login" element={<Navigate to="/ADMIN" replace />} />
        <Route path="/vendedor/:empresaId" element={<LoginVendedor />} />
        <Route path="/vendedor/eventos" element={<VendedorPanel />} />
        <Route path="/cliente/eventos" element={<ClienteEventos />} />
        <Route path="/cliente/vendedores" element={<ClienteVendedores />} />
        <Route path="/cliente/invitados/:idEvento" element={<ClienteInvitados />} />
        <Route path="/cliente/estadisticas/:idEvento" element={<ClienteEstadisticas />} />
        <Route path="/i/:clienteId/:idEvento/:vendedorId" element={<InscripcionCliente />} />
        <Route path="/i/:clienteId/:idEvento" element={<InscripcionCliente />} />
        <Route path="/espera/:empresaId/:eventoId" element={<WaitlistForm />} />
        <Route path="/espera/:empresaId/:eventoId/estado/:dni" element={<WaitlistEstado />} />
        <Route path="/vendedor/invitados" element={<VendedorPanel />} />
        <Route path="/admin" element={<AdminAccess />} />
        <Route path="/pagar/:inscripcionId" element={<SubirComprobante />} />
        <Route path="/comprar/:empresaId" element={<ComprarEmpresa />} />
        <Route path="/comprar/:empresaId/resultado" element={<CompraResultado />} />
        <Route path="/scanner/login" element={null} />
        <Route path="/:empresaId/scanner/login" element={<ScannerLogin />} />
        <Route path="/:empresaId/scanner" element={<QrScanner />} />
        <Route path="/:empresaId/admin" element={<LoginPlataforma />} />
        <Route
          path="/invitados"
          element={
            <ProtectedRoute>
              <GuestList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/estadisticas"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/scanner" element={null} />
        <Route path="/:empresaId" element={<LoginVendedor />} />
        <Route path="*" element={<SplashRedirect />} />
      </Routes>


      {/* 👉 Mostrar u ocultar el BottomBar */}
      {!shouldHideBottom &&
        (localStorage.getItem("loginType") === "1" ? (
          <BottomBarAdmin />
        ) : (
          <BottomBar />
        ))}
    </main>
  );
}

export default function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (showSplash) {
    return (
      <Router>
        <SplashScreen />
      </Router>
    );
  }

  return (
    <Router>
      <EmpresaProvider>
        <AppContent />
      </EmpresaProvider>
    </Router>
  );
}
